import { Controller } from "@hotwired/stimulus"

// Tarjeta Stock: switch, cantidad (fieldset deshabilitado apagado) y resumen; el candado del plan lo
// decide la vista. Publica data-stock-*. Doc: _docs/features/products/partner_product_form.md
export default class extends Controller {
  static targets = ["active", "body", "quantity", "summaryShort", "summaryLong"]

  connect() {
    this.refresh()
  }

  toggleHeader() {
    if (this.hasActiveTarget && !this.activeTarget.disabled) this.activeTarget.click()
  }

  // Borrador local: switch y cantidad; sin inputs no hay nada que guardar
  get draft() {
    if (!this.hasActiveTarget) return null
    const raw = this.hasQuantityTarget ? this.quantityTarget.value : ""
    const quantity = Number(raw)
    return { active: this.activeTarget.checked, quantity: raw !== "" && Number.isFinite(quantity) ? quantity : null }
  }

  restoreDraft(stock) {
    if (!this.hasActiveTarget || this.activeTarget.disabled) return { skipped: stock?.active ? 1 : 0 }
    this.activeTarget.checked = Boolean(stock?.active)
    if (this.hasQuantityTarget && !this.quantityTarget.readOnly) {
      this.quantityTarget.value = stock?.quantity ?? ""
      this.quantityTarget.dispatchEvent(new Event("input", { bubbles: true }))
    }
    this.refresh()
    return { skipped: 0 }
  }

  refresh() {
    const on = this.hasActiveTarget && this.activeTarget.checked
    if (this.hasBodyTarget) {
      this.bodyTarget.hidden = !on
      this.bodyTarget.disabled = !on
    }
    const quantity = on && this.hasQuantityTarget ? Number(this.quantityTarget.value) : null
    const units = quantity === null || !Number.isFinite(quantity) ? null : quantity
    const short = on ? (units === null ? "Sin cantidad" : `${units} ${units === 1 ? "disponible" : "disponibles"}`) : "Ilimitado"
    if (this.hasSummaryShortTarget) this.summaryShortTarget.textContent = short
    if (this.hasSummaryLongTarget) this.summaryLongTarget.textContent = on && units !== null ? `${short} · cada venta descuenta 1` : short
    this.element.dataset.stockActive = on
    this.element.dataset.stockQuantity = units === null ? "" : units
  }
}
